import { NgModule } from '@angular/core';
import { LogCorrectionsFormComponent } from './corrections-form.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import {
  CheckboxGroupModule,
  DatePickerModule,
  NumberInputModule,
  RadioGroupModule,
  SelectModule,
  SwitchModule,
} from '@certemy/ui-components';
import { DynamicFormModule } from 'components/dynamic-form/dynamic-form.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    SwitchModule,
    RadioGroupModule,
    CheckboxGroupModule,
    DatePickerModule,
    DynamicFormModule,
    SelectModule,
    NumberInputModule,
  ],
  exports: [LogCorrectionsFormComponent],
  declarations: [LogCorrectionsFormComponent],
})
export class LogCorrectionsFormModule {}
